/**
 * 路由配置文件
 * 定义应用的所有路由和导航守卫
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由配置 - 使用懒加载提升性能
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/Register.vue')
    },
    {
        path: '/products',
        name: 'Products',
        component: () => import('@/views/Products.vue')
    },
    {
        path: '/product/:id',
        name: 'ProductDetail',
        component: () => import('@/views/ProductDetail.vue')
    },
    {
        path: '/product-upload',
        name: 'ProductUpload',
        component: () => import('@/views/ProductUpload.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/user-profile',
        name: 'UserProfile',
        component: () => import('@/views/UserProfile.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/withdrawal',
        name: 'Withdrawal',
        component: () => import('@/views/Withdrawal.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () => import('@/views/Admin.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
    }
]

// 创建路由实例
const router = new VueRouter({
    mode: 'history', // 使用 hash 模式，URL 带 # 号，刷新不会404
    routes
})

/**
 * 全局前置守卫
 * 检查需要认证的路由，未登录用户重定向到登录页
 * 检查管理员权限，非管理员用户无法访问管理页面
 * 产品详情页未登录用户直接访问时重定向到首页
 */
router.beforeEach((to, from, next) => {
    // 产品详情页未登录用户直接访问时重定向到首页
    if (to.path.startsWith('/product/') && to.path !== '/product-upload' && !from.name) {
        const userStr = localStorage.getItem('currentUser')
        if (!userStr) {
            next('/')
            return
        }
    }

    if (to.meta.requiresAuth) {
        // 检查用户是否登录
        const userStr = localStorage.getItem('currentUser')
        if (userStr) {
            try {
                const user = JSON.parse(userStr)

                // 检查是否需要管理员权限
                if (to.meta.requiresAdmin && user.role !== 'admin' && user.role !== 'sub_admin') {
                    next('/') // 非管理员用户重定向到首页
                    return
                }

                next() // 已登录且权限正确，允许访问
            } catch (e) {
                // 用户信息解析失败，清除无效数据
                localStorage.removeItem('currentUser')
                localStorage.removeItem('token')
                next('/login')
            }
        } else {
            next('/login') // 未登录，重定向到登录页
        }
    } else {
        next() // 不需要认证，直接访问
    }
})

export default router
